import React from "react";
import { Grid, Grid as MuiGrid } from "@mzc-pdc/ui";
import { styled } from "@mui/material";
import OverflowTooltip from "@components_v2/ellipsis-tooltip/overflow-tooltip";

export const StyledGrid = styled(MuiGrid)(({ theme, usePadding = true, useBorder = true }) => ({
    width: `-webkit-fill-available`,
    padding: usePadding ? "20px " : "0",
    ...(useBorder
        ? {
              borderRadius: `4px`,
              border: `1px solid ${theme.palette.greySecondary[100]}`,
          }
        : {}),
}));

const StyledGridNameEllipsis = styled(Grid)(({ theme, maxWidth }) => ({
    flex: maxWidth ? undefined : 1,
    maxWidth: maxWidth,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
}));

/**
 * 이름을 한 줄 말줄임으로 표시하는 Grid.
 * 실제로 잘린 경우에만 렌더된 텍스트를 툴팁으로 노출한다. (DAM-306)
 *
 * @param {React.ReactNode} tooltipTitle 툴팁 문구를 직접 지정할 때 사용. 생략하면 자식의 텍스트를 그대로 쓴다.
 */
export const GridNameEllipsis = ({ tooltipTitle, tooltipPlacement = "bottom", children, ...rest }) => (
    <OverflowTooltip title={tooltipTitle} placement={tooltipPlacement}>
        <StyledGridNameEllipsis {...rest}>{children}</StyledGridNameEllipsis>
    </OverflowTooltip>
);
